import { Action, handleActions } from 'redux-actions';
import { Article } from '../contentful/contentfulClient';
import { ArticlesActionType } from './ArticlesActions';
import { articlesInitialState, ArticlesState } from './ArticlesState';

const articlesReducer = handleActions<ArticlesState, any>(
    {
        [ArticlesActionType.ARTICLES_LOAD_START]: (state: ArticlesState) => (
            {
                ...state,
                list: [],
                loaded: false
            }
        ),
        [ArticlesActionType.ARTICLES_LOADING]: (state: ArticlesState) => (
            {
                ...state,
                loading: true,
            }
        ),
        [ArticlesActionType.ARTICLES_LOAD_FAILED]: (state: ArticlesState) => (
            {
                ...state,
                list: [],
                loaded: false,
                loading: false,
            }
        ),
        [ArticlesActionType.ARTICLES_LOAD_SUCCESS]: (state: ArticlesState, action: Action<Array<Article>>) => (
            {
                ...state,
                list: action.payload!,
                loading: false,
                loaded: true,
            }
        )
    },
    articlesInitialState
);

export default articlesReducer;


// WEBPACK FOOTER //
// ./src/article/ArticlesReducer.ts